// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCheck.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCheck = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="m13.47838,2l-7.49832,7.6857l-3.51228,-3.32956l-2.46777,2.4691l5.98005,5.79932l9.96676,-10.15612l-2.46843,-2.46843z" />
  </BaseIcon>
);

export default IconCheck;
